import { useContextState } from '../../../../../../../hooks/theme'
import { SxProps, Theme } from '@mui/system'

export const getChartStyles = () => {
  const { colors: color } = useContextState()

  const chartPanel: SxProps<Theme> = {
    flex: 1,
    minWidth: '300px',
    height: '400px',
    maxHeight: '400px',
    borderRadius: '4px',
    boxShadow: `0 0 2px 0px ${color.color13}`,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  }

  const chartPanelHeader: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '20px 18px',
    borderRadius: '2px',
  }

  const chartPanelTitle: SxProps<Theme> = {
    fontSize: '16px',
    fontWeight: 500,
    color: color.color13,
  }

  const chartPanelIcons: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  }

  const emptyProcessPanel: SxProps<Theme> = {
    flex: 1,
    backgroundColor: color.color5,
  }

  return {
    chartPanel,
    chartPanelHeader,
    chartPanelTitle,
    chartPanelIcons,
    emptyProcessPanel,
  }
}
